export const updateHeight = ( height ) => {
  return {
    type : 'UPDATE_HEIGHT',
    payload : height
  };
};